angular.module('data-ng-path-item').constant('ItemFn', {
  hasChildren: function (item) {
    return !_.isEmpty(item.children);
  }
});



// WEBPACK FOOTER //
// ./app/vendor/data-ng-path-item/src/functions/item_fn.js